import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification',
  templateUrl: './help-add-notification.component.html',
  styleUrls: ['./help-add-notification.component.scss']
})
export class HelpAddNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
